import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative bg-cream pt-32 pb-20 px-6 md:pt-40 md:pb-28 overflow-hidden" data-id="element-84">
      <div className="max-w-[1100px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-start space-y-6" data-id="element-86">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-forest leading-tight" data-id="element-87">
            ARRÊTEZ DE SUBIR L'INFLATION ALIMENTAIRE.
          </h1>

          <h2 className="font-sans text-xl md:text-2xl font-semibold text-charcoal leading-snug" data-id="element-88">
            Récoltez jusqu'à 15kg de nourriture fraîche par mois sur seulement
            1m².
          </h2>

          <p className="font-sans text-lg text-charcoal/80 max-w-lg" data-id="element-89">
            Le Système "Anti-Épicerie" pour transformer votre balcon ou rebord
            de fenêtre en mine d'or verte.
          </p>

          <div className="pt-4 w-full sm:w-auto" data-id="element-90">
            <button onClick={() => document.getElementById('cta-section')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full sm:w-auto bg-forest hover:bg-forest-light text-white font-sans font-bold text-lg py-4 px-8 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1" data-id="element-91">
              DÉCOUVRIR LE SYSTÈME
            </button>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative flex justify-center lg:justify-end" data-id="element-92">
          <div className="relative w-full max-w-md aspect-square rounded-2xl overflow-hidden shadow-2xl" data-id="element-93">
            <img src="https://cdn.magicpatterns.com/uploads/xmYHidf66EEvJK3rxLbFnP/COVER_EBOOK_PRINCIPAL.png" alt="Récolte Urbaine - L'Ebook Maître" className="object-cover w-full h-full" data-id="element-94" />
            <div className="absolute inset-0 bg-gradient-to-tr from-forest/20 to-transparent mix-blend-overlay" data-id="element-95"></div>
          </div>

          {/* Decorative elements */}
          <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-accent rounded-full opacity-20 blur-2xl" data-id="element-96"></div>
          <div className="absolute -top-6 -right-6 w-32 h-32 bg-forest rounded-full opacity-10 blur-2xl" data-id="element-97"></div>
        </motion.div>
      </div>
    </section>;
}